<div class="row h-75">
	<div class="container border rounded pt-4 pb-2">
		<div class="row my-2 theme-main-color text-center">
			<div class="row my-2">
				<span> {{ displayText }} </span>
			</div>
		</div>
	</div>
</div>
